export const HOLDOUT = 'holdout';
export const COMMITTED = 'committed';



// WEBPACK FOOTER //
// ./src/lib/membership-statuses.js